module.exports = __webpack_public_path__ + "img/share-card.48ebc4ef.jpg";